import { OrderDues } from '../data_types/member-order';

export const calculateDuesTotal = (dues: OrderDues | undefined): number => {
    const prices: (number | null | undefined)[] = [dues?.Local?.price, dues?.State?.price, dues?.National?.price];
    return prices.reduce((a: number, b) => a + (b || 0), 0);
};
